module.exports = __webpack_public_path__ + "LIFAN-logo.png";